module.exports = __webpack_public_path__ + "img/Czech Embassy Logo.8fa05523.png";